import {AspectRatio, Image, Card, Text, Title, Box, Center} from "@mantine/core";
import {AttachmentPath} from "src/entities/attachments";
import {Products} from "src/entities/products";
import {COLORS} from "src/constants";
import {useMediaQuery} from "@mantine/hooks";
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import {Content} from "src/shared/helpers/content";

type Props = {
    data: Products
}

export const ProductCard = ({data}: Props) => {
    const {i18n} = useTranslation()
    const locale = i18n.language
    const fileUrl = data?.photoAttachments?.[0]?.id ? AttachmentPath.GetAttachmentUrl(data?.photoAttachments?.[0]?.id) : "/img/product.png"
    return (
            <Link to={`/${locale}/category/${data?.category?.id ?? 1}/product/${data.id}`}>
                <Card shadow="xl" p={0} radius="md">
                            <AspectRatio mb={{base: 0, sm: 12}} w="100%" ratio={1}>
                                <Center>
                                    <img
                                        style={{objectFit: "contain", borderRadius: "8px 8px 0 0"}}
                                        width="50%" height="50%" src={fileUrl}/>
                                </Center>
                            </AspectRatio>
                    <Box p={12}>
                        <Title lh={1.2} mb={{base: 4, sm: 12}} c={COLORS.TRIOTERY_COLOR} fz={{base: 16, sm: 20}} fw={600} lineClamp={2}>
                                    {Content.GetTitleByLanguage(data, locale)}
                                </Title>
                                <Text  fz={14} fw={400} c={COLORS.SECONDARY_COLOR} lineClamp={2}>
                                    {Content.HtmlRenderFromLocale({
                                        titleKg: data?.contentKg,
                                        titleRu: data?.contentRu,
                                    }, locale)}
                                </Text>
                            </Box>
                </Card>
            </Link>
    )
}